<div class="row">
  <div class="col">
    <h2>{{medium}} / <code>{{q}}</code></h2>
  </div>
</div>

<div class="row" *ngIf="!loading">
  <div class="col" style="width: 50vw; height: 50vh;">
    <ng-lottie [options]="options" (loopComplete)="onLoopComplete()"></ng-lottie>
  </div>
</div>

<div class="d-flex flex-wrap justify-content-center" *ngIf="loading">
  <div class="card text-white bg-dark m-3" style="width: 18rem;" *ngFor="let sr of searchResults; let i = index">
    <img class="card-img-top" src="{{sr.image}}" alt="Card image cap">
    <div class="card-body">
      <h5 class="card-title">{{sr.title}}</h5>
      <p class="card-text">{{sr.synopsis}}</p>
      <a href="{{sr.url}}" target="_blank"><button type="button" class="btn btn-info btn-block" href="">More info..</button></a>
      <button type="button" class="btn btn-outline-warning" *ngIf="canShare" (click)="shareThis(i)">Share</button>
    </div>
  </div>
</div>


<!-- <div class="row" *ngFor="let sr of searchResults; let i = idx">
  <div class="col">
    <img src="{{sr.image}}" alt="cover picture">
    <h3 class="title">
      {{sr.title}}
    </h3>
    <p>
      {{sr.synopsis}}
    </p>
  </div>
  <button type="button" class="btn btn-outline-warning" *ngIf="canShare" (click)="shareThis(i)">Share</button>
</div> -->



<button (click)="goToList()" class="btn btn-warning" *ngIf="loading">Search More</button>